import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Select, DatePicker, Switch, Radio } from 'antd';
import moment from 'moment';
import axios from '../backendService';
const { Option } = Select;
const { TextArea } = Input;

const UserModal = ({ visible, onCancel, onSave, user, roles, courses, batches, subjects }) => {
  const [form] = Form.useForm();
  const [selectedRole, setSelectedRole] = useState('');
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [cities, setCities] = useState([]);
  const [isEditMode, setIsEditMode] = useState([]);
  // console.log(roles,"asdasdddff")

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await axios.get('/location');
        setStates(response.data[0].states); // Assuming the response is an array with one object for India
      } catch (error) {
        console.error('Error fetching locations:', error);
      }
    };
    fetchLocations();
  }, []);

  const onStateChange = (value) => {
    setSelectedState(value);
    const selectedStateObj = states.find((state) => state.name === value);
    if (selectedStateObj) {
      setCities(selectedStateObj.cities);
    }
  };

  // Asynchronous validator for checking if the email exists
  const checkEmailExists = async (_, email) => {
    if (!email) {
      return Promise.resolve();
    }
    // Check if the email belongs to the editing user
    if (user && email === user.email) {
      return Promise.resolve();
    }
    try {
      const response = await axios.post('/users/email', { email });
      if (response.data.success && response.data.status_code === 400) {
        return Promise.reject(new Error('Email already registered'));
      }
      return Promise.resolve();
    } catch (error) {
      // Handle error appropriately
      const errorMessage = error.response?.data.message || 'An error occurred while checking the email';
      return Promise.reject(new Error(errorMessage));
    }
  };

  // Asynchronous validator for checking if the phone number exists
  const checkPhoneNumberExists = async (_, phoneNumber) => {
    if (!phoneNumber) {
      return Promise.resolve();
    }
    // Normalize phone numbers to ensure format match
    const inputPhoneNumber = phoneNumber.toString().trim();
    const currentPhoneNumber = user?.phoneNumber?.toString().trim();

    // Check if the phone number belongs to the editing user and skip the check if it does
    if (currentPhoneNumber && inputPhoneNumber === currentPhoneNumber) {
      return Promise.resolve();
    }

    try {
      const response = await axios.post('/users/exist', { phoneNumber });
      if (response.data.success && response.data.status_code === 400) {
        return Promise.reject(new Error('Phone number already registered'));
      }
      return Promise.resolve();
    } catch (error) {
      // Handle error appropriately
      const errorMessage = error.response?.data.message || 'An error occurred while checking the phone number';
      return Promise.reject(new Error(errorMessage));
    }
  };

  //   useEffect(() => {
  //     // Set initial form values when the modal is opened
  //     form.resetFields();
  //     if (user) {
  //       form.setFieldsValue({
  //         ...user,
  //         dob: moment(new Date(user.dob)),
  //         gender: user.gender || 'male',
  //         courses: user.courses || [], // Ensure courses is initialized as an empty array
  //         subjects: user.subjects || [], // Ensure subjects is initialized as an empty array
  //       });
  //       setSelectedRole(user.userType === 1 ? 'Student' : 'Teacher');
  //     } else {
  //         // Set default values for a new user
  //         form.setFieldsValue({
  //           gender: 'male',
  //           courses: [],
  //           subjects: [],
  //         });}
  //   }, [user, visible, form]);

  useEffect(() => {
    // Set initial form values when the modal is opened
    form.resetFields();
    if (user) {
      // console.log(user,"from edit modal----")
      const { userType, courses, batches, subjects, ...otherUserProps } = user;
      // const roleName= roles.filter((role)=>role._id===user.role)[0].roleName
      // console.log("roleNmae",roleName)
      form.setFieldsValue({
        ...otherUserProps,
        dob: moment(new Date(user.dob)),
        gender: user.gender || 'male',
        // courses: userType === 1 ? courses.map((course) => course._id) : [],
        courses: courses ? courses.map((course) => course._id) : [],
        batches: batches ? batches.map((batch) => batch._id) : [],
        subjects: userType === 2 ? subjects.map((subject) => subject._id) : [], // Extract subject IDs
        role: user.role,
        // role:roleName
      });
      setSelectedRole(userType === 1 ? 'Student' : 'Teacher');
    } else {
      // Set default values for a new user
      form.setFieldsValue({
        // ... (other fields)
        courses: [],
        subjects: [],
        batches: [],
      });
    }
  }, [user, visible, form]);
  //   const handleRoleChange = (value) => {
  //     setSelectedRole(value);
  //   };

  // const handleRoleChange = (value) => {
  //     setSelectedRole(value);

  //     // Assuming you have a way to map role IDs to status values
  //     const status = value === 'Student' ? 1 : value === 'Teacher' ? 2 : null;
  //     form.setFieldsValue({ status }); // Set status based on the selected role

  //     const userType = value === 'Student' ? 1 : value === 'Teacher' ? 2 : null;
  //     form.setFieldsValue({ userType }); // Set userType based on the selected role
  //   };

  const handleRoleChange = (value) => {
    setSelectedRole(value);
    form.setFieldsValue({
      status: value === 'Student' ? 1 : value === 'Teacher' ? 2 : null,
      // userType: value === 'Student' ? 1 : value === 'Teacher' ? 2 : null,
    });
  };

  const onCourseSelect = (selectedCourses) => {
    form.setFieldsValue({ courses: selectedCourses });
  };

  const onBatchSelect = (selectedBatches) => {
    form.setFieldsValue({ batches: selectedBatches });
  };

  const onSubjectSelect = (selectedSubjects) => {
    console.log(selectedSubjects, 'sleelcew');
    // form.setFieldValue({ subjects: selectedSubjects });
    form.setFieldsValue({ subjects: selectedSubjects });
  };

  const onSubjectContentSelect = (selectedSubjects) => {
    console.log(selectedSubjects, 'sleelcew');
    // form.setFieldValue({ subjects: selectedSubjects });
    form.setFieldsValue({ subjects: selectedSubjects });
  };

  const roleStatusMap = {
    Student: 1,
    Teacher: 2,
    Admin: 3,
    'Content Management': 4,
  };

  return (
    <Modal
      visible={visible}
      title={user ? 'Edit User' : 'Add User'}
      okText="Save"
      cancelText="Cancel"
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            onSave({
              // ...values,
              // role: roles.find((role) => role._id === values.role)?.roleName || 'Default Role',
              // //   userType: selectedRole === 'Student' ? 1 : 2,
              // courses:
              //   // selectedRole === 'Student' ? values.courses.map((course) => ({ _id: course, courseName: '' })) : [],
              //   selectedRole === 'Student' ? values.courses.map((course) => (course)) : [],
              //   subjects:
              //   selectedRole === 'Teacher' ? values.subjects.map((subject) => (subject)) : [],
              //   // selectedRole === 'Teacher' ? values.subjects.map((subject) => ({ _id: subject, subjectName: '' })) : [],
              // // Add other fields as needed based on your requirements
              // // For example, 'status' field based on the selected role
              // status: selectedRole === 'Student' ? 1 : 2,

              ...values,
              // role: roles.find((role) => role._id === values.role)?.roleName || 'Default Role',
              // role: roles.find((role) => role._id === values.role) || 'Default Role',
              // courses: selectedRole === 'Student' ? values.courses.map((course) => (course)) : [],
              // courses: values.courses.map((course) => course),
              courses: (values.courses || []).map((course) => course),
              batches: (values.batches || []).map((batch) => batch),
              // subjects: selectedRole === 'Teacher' ? values.subjects.map((subject) => subject) : [],
              subjects:
                selectedRole === 'Teacher' || selectedRole === 'Content Management'
                  ? values.subjects.map((subject) => subject)
                  : [],
              status: roleStatusMap[selectedRole] || 0,
              userType: roleStatusMap[selectedRole] || 0,
              // status: selectedRole === 'Student' ? 1 : 2,
            });
          })
          .catch((error) => {
            console.error('Validation Error:', error);
          });
      }}
    >
      <Form form={form} layout="vertical" name="userForm">
        <Form.Item name="role" rules={[{ required: true, message: 'Please select a role' }]}>
          <Select placeholder="Role" onChange={handleRoleChange} disabled={!!user}>
            {roles.map((role) => (
              <Option key={role._id} value={role.roleName}>
                {role.roleName}
              </Option>
            ))}
          </Select>
        </Form.Item>

        {/* <Form.Item
          name="phoneNumber"
          rules={[
            { required: true, message: 'Please enter phone number' },
            { validator: checkPhoneNumberExists },
            () => ({
              validator(_, value) {
                if (!value || value.length === 10) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('Phone number must be exactly 10 digits'));
              },
            }),
          ]}
        >
          <Input placeholder="Phone Number" />
        </Form.Item> */}

        {selectedRole === 'Content Management' ? (
          <>
            <Form.Item name="userName" rules={[{ required: true, message: 'Please enter user name' }]}>
              <Input placeholder="User Name" />
            </Form.Item>

            <Form.Item
              name="phoneNumber"
              rules={[
                { required: true, message: 'Please enter phone number' },
                () => ({
                  validator(_, value) {
                    // Assuming 'user' is the prop passed down to the component when editing
                    if (user && value === user.phoneNumber) {
                      // If in edit mode and the phone number hasn't changed, skip the length validation
                      return Promise.resolve();
                    }
                    // Check if the value is present and is exactly 10 digits long
                    if (!value || value.replace(/\s+/g, '').length === 10) {
                      return Promise.resolve();
                    }
                    // If it doesn't match the criteria, reject the promise
                    return Promise.reject(new Error('Phone number must be exactly 10 digits'));
                  },
                }),
                { validator: checkPhoneNumberExists },
              ]}
            >
              <Input placeholder="Phone Number" />
            </Form.Item>

            <Form.Item
              name="email"
              rules={[
                { required: true, message: 'Please enter email' },
                { type: 'email', message: 'Please enter a valid email!' },
                { validator: checkEmailExists },
              ]}
            >
              <Input placeholder="Email" />
            </Form.Item>

            <Form.Item
              name="subjects"
              rules={[{ required: selectedRole === 'Teacher', message: 'Please select at least one subject' }]}
            >
              <Select
                mode="multiple"
                placeholder="Select subjects"
                disabled={selectedRole === 'Student'}
                onChange={onSubjectSelect}
              >
                {subjects.map((subject) => (
                  <Option key={subject._id} value={subject._id}>
                    {subject.subjectName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            {/* <Form.Item name="password" rules={[{ required: false, message: 'Please input your password!' }]}>
              <Input.Password placeholder="Input password" />
            </Form.Item> */}
            <Form.Item
              name="password"
              rules={[{ required: selectedRole !== 'Student', message: 'Please input your password!' }]}
            >
              <Input.Password placeholder="Input password" />
            </Form.Item>
          </>
        ) : (
          <>
            <Form.Item name="userName" rules={[{ required: true, message: 'Please enter user name' }]}>
              <Input placeholder="User Name" />
            </Form.Item>
            <Form.Item
              name="phoneNumber"
              rules={[
                { required: true, message: 'Please enter phone number' },
                () => ({
                  validator(_, value) {
                    // Assuming 'user' is the prop passed down to the component when editing
                    if (user && value === user.phoneNumber) {
                      // If in edit mode and the phone number hasn't changed, skip the length validation
                      return Promise.resolve();
                    }
                    // Check if the value is present and is exactly 10 digits long
                    if (!value || value.replace(/\s+/g, '').length === 10) {
                      return Promise.resolve();
                    }
                    // If it doesn't match the criteria, reject the promise
                    return Promise.reject(new Error('Phone number must be exactly 10 digits'));
                  },
                }),
                { validator: checkPhoneNumberExists },
              ]}
            >
              <Input placeholder="Phone Number" />
            </Form.Item>

            <Form.Item
              name="email"
              rules={[
                { required: true, message: 'Please enter email' },
                { type: 'email', message: 'Please enter a valid email!' },
                { validator: checkEmailExists },
              ]}
            >
              <Input placeholder="Email" />
            </Form.Item>

            <Form.Item
              className={`${selectedRole !== 'Teacher' ? 'hidden' : ''}`}
              name="description"
              rules={[
                { required: selectedRole === 'Teacher' ? true : false, message: `Please enter teacher description` },
              ]}
            >
              <TextArea placeholder="Enter description" disabled={selectedRole !== 'Teacher'} />
            </Form.Item>
            {/* Adjusted handling of courses and subjects */}

            <Form.Item
              name="courses"
              rules={[{ required: selectedRole === 'Student', message: 'Please select at least one course' }]}
            >
              <Select
                mode="multiple"
                placeholder="Select courses"
                // disabled={selectedRole === 'Teacher'}
                onChange={onCourseSelect}
              >
                {courses.map((course) => (
                  <Option key={course._id} value={course._id}>
                    {course.courseName}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {/* Select batches */}
            <Form.Item
              name="batches"
              rules={[{ required: selectedRole === 'Teacher', message: 'Please select at least one batch' }]}
            >
              <Select
                mode="multiple"
                placeholder="Select batches"
                disabled={selectedRole !== 'Teacher'}
                onChange={onBatchSelect}
              >
                {batches.map((batch) => (
                  <Option key={batch._id} value={batch._id}>
                    {batch.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {(selectedRole === 'Teacher' || !user) && (
              <>
                <Form.Item
                  name="subjects"
                  rules={[{ required: selectedRole === 'Teacher', message: 'Please select at least one subject' }]}
                >
                  <Select
                    mode="multiple"
                    placeholder="Select subjects"
                    disabled={selectedRole === 'Student'}
                    onChange={onSubjectSelect}
                  >
                    {subjects.map((subject) => (
                      <Option key={subject._id} value={subject._id}>
                        {subject.subjectName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                {/* <Form.Item name="password" rules={[{ required: false, message: 'Please input your password!' }]}>
              <Input.Password placeholder="Input password" />
            </Form.Item> */}
                {selectedRole !== 'Student' && (
                  <Form.Item
                    name="password"
                    rules={[{ required: selectedRole !== 'Student', message: 'Please input your password!' }]}
                  >
                    <Input.Password placeholder="Input password" />
                  </Form.Item>
                )}
              </>
            )}

            <Form.Item name="dob" rules={[{ required: false, message: 'Please select a date of birth' }]}>
              <DatePicker placeholder="Date of Birth" style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item
              name="state"
              // label="State"
              rules={[{ required: true, message: 'Please select your state' }]}
            >
              <Select placeholder="Select a state" onChange={onStateChange}>
                {states.map((state) => (
                  <Option key={state.name} value={state.name}>
                    {state.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="city"
              // label="City"
              rules={[{ required: true, message: 'Please select your city' }]}
            >
              <Select placeholder="Select a city" disabled={!selectedState}>
                {cities.map((city) => (
                  <Option key={city} value={city}>
                    {city}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item name="gender" rules={[{ required: true, message: 'Please select a gender' }]}>
              <Radio.Group>
                <Radio value="male">Male</Radio>
                <Radio value="female">Female</Radio>
                <Radio value="other">Other</Radio>
              </Radio.Group>
            </Form.Item>
          </>
        )}

        {/* <Form.Item name="city" rules={[{ required: true, message: 'Please enter a city' }]}>
          <Input placeholder="City" />
        </Form.Item>

        <Form.Item name="state" rules={[{ required: true, message: 'Please enter a state' }]}>
          <Input placeholder="State" />
        </Form.Item> */}
      </Form>
    </Modal>
  );
};

export default UserModal;
